<template>
  <div class="terminal-pc">
    <div class="w1200 pt96 pb48 center">
      <div class="lz-title1 mb8">PC端独立官网</div>
      <div class="T6 EC3 mb64 lz-desc2">不止是网校，更是你的品牌官网</div>
      <div class="lz-img">
        <img :src="require('@/assets/images/terminalPic8.jpg')" />
      </div>
    </div>
    <div class="w1200 pt64 pb64">
      <ul class="three-function">
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 iconfont iconicon_Learn"></i>
          </div>
          <p class="EC2 T5 mb8">沉浸式学习</p>
          <p class="EC2 T5 mb8">优化学习体验</p>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 iconfont iconicon_website"></i>
          </div>
          <p class="EC2 T5 mb8">个性化官网</p>
          <p class="EC2 T5 mb8">拓展获客渠道</p>
        </li>
        <li class="function-item center">
          <div class="icon">
            <i class="EC1 iconfont iconicon_domainname"></i>
          </div>
          <p class="EC2 T5 mb8">自定义域名</p>
          <p class="EC2 T5 mb8">提升品牌形象</p>
        </li>
      </ul>
    </div>
    <div class="lz-modules1 w1200">
      <div class="module-box pt64 pb64 row-reverse TA_left">
        <div class="module-text">
          <div class="title EC2 mb24 T4 sub_title">自定义域名 提升品牌形象</div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              支持域名自定义，打造独立的品牌形象
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic9_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic9.jpg')"
            alt=""
          />
        </div>
      </div>
      <div class="module-box pt64 pb64 TA_left">
        <div class="module-text">
          <div class="title EC2 mb24 T4 sub_title">
            增强搜索引擎曝光 实现精准SEO
          </div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              可设置店铺的TDK元素，让官网在搜索引擎中的排名更靠前
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic10_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic10.jpg')"
            alt=""
          />
        </div>
      </div>

      <div class="module-box pt64 row-reverse pb64 TA_left">
        <div class="module-text">
          <div class="title EC2 mb24 T4 sub_title">
            丰富课堂形式 满足多种学习需求
          </div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              完美适配PC端，覆盖直播、图文、音视频等课程形式
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic11_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic11.jpg')"
            alt=""
          />
        </div>
      </div>

      <div class="module-box pt64 pb64 TA_left">
        <div class="module-text">
          <div class="title EC2 mb24 T4 sub_title">
            灵活店铺装修 打造个性化页面
          </div>
          <div class="module-text-item mb16">
            <div class="desc EC3 T6 lz-desc2">
              页脚版权信息、贴片广告位等位置自定义 塑造自有品牌标识度
            </div>
          </div>
        </div>
        <div class="module-img lz-img">
          <img
            v-if="$store.state.sceneClassName === 'app'"
            :src="require('@/assets/images/terminalPic12_app.png')"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/images/terminalPic12.jpg')"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'terminalPc',
  data() {
    return {};
  },
  components: {},
  mounted() {
  },
  methods: {

  }
};
</script>

<style lang="scss">
.terminal-pc {
  .three-function {
    display: flex;
    justify-content: space-between;
    .function-item {
      width: 368px;
      height: 260px;
      padding-top: 52px;
      background: #fff;
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.06),
        0 20px 40px 0 rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      .icon {
        margin-bottom: 30px;
        .iconfont {
          font-size: 64px;
        }
      }
    }
  }
}
.app {
  .three-function {
    padding: 0.64rem 0.3rem 0;
    flex-wrap: wrap;
    .function-item {
      margin-bottom: 0.48rem;
      width: 48%;
      height: 3.68rem;
      box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.06);
      border-radius: 0.16rem;
      padding-top: 0.48rem;
      .icon {
        display: inline-block;
        width: 1.44rem;
        height: 1.44rem;
        line-height: 1.44rem;
        margin-bottom: 0;
        background: #266cff;
        border-radius: 50%;
        i {
          font-size: 0.84rem !important;
          color: #ffffff;
        }
      }
      p {
        margin-top: 0.22rem;
        font-size: 0.32rem;
        font-weight: 600;
        margin-bottom: 0;
      }
    }
  }
  .module-text {
    text-align: center;
  }
  .module-box:nth-child(odd) {
    background: #f6f9ff;
  }
  .lz-modules1 {
    .module-box {
      padding-bottom: 1.28rem;
    }
    .module-text-item {
      width: auto;
      margin: 0;
    }
    .lz-desc2 {
      margin-top: 0;
    }
  }
}
</style>
